import {
  DiaHorarioKinesioBody,
  DiaHorarioKinesioBoton,
  DiaHorarioKinesioContainer,
  DiaHorarioKinesioFooter,
  DiaHorarioKinesioHeader,
} from "./localStyle";
import Layout from "_+_Portal/components/Genericos/Layout/Layout";
import { useContext, useState } from "react";
import { useHistory, useLocation } from "react-router";
import FiltroCheck from "./FiltroCheck/FiltroCheck";
import {
  createDtoTurnosDisponiblesKin,
  dias,
  horario,
} from "./dtoFiltroKinesio";
import { GlobalContext } from "global/context/Provider";
import {
  hideToaster,
  showToaster,
} from "global/context/action/toaster/toaster";
import { wsPostTurnosKinesioQr } from "_+_Portal/context/Actions/turnos/estudioTurnos";
import { PortalContext } from "_+_Portal/context/Provider";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { setNuevoTurno } from "_+_Portal/context/Actions/nuevoTurno/nuevoTurno";
import BarraAzul from "_+_Portal/_-_Autocheckin/components/genericos/BarraAzul/BarraAzul";
import { editaTurnosDisponibles } from "_+_Portal/context/Actions/turnos/turnosDisponibles";

const DiaHorarioKinesio = () => {
  //#region --------- context ---------------
  const { configState, toasterDispatch } = useContext(GlobalContext);
  const {
    turnosDisponiblesState,
    turnosDisponiblesDispatch,
    nuevoTurnoState,
    nuevoTurnoDispatch,
    estudioTurnosDispatch,
  } = useContext(PortalContext);

  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const [loading, setLoading] = useState(false);
  const [diasSeleccionados, setDiasSeleccionados] = useState(dias);
  const [rangoHorarioSeleccionado, setRangoHorarioSeleccionado] =
    useState(horario);
  const history = useHistory();
  const pacienteSeleccionado = nuevoTurnoState.nuevoTurno.familiar?.paciente;
  const dtoBusqueda = nuevoTurnoState.nuevoTurno.dtoBusqueda;
  const sectorTurno = configState.config.data?.sectorTurno;
  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------
  const obtenerFechaDeHoy = () => {
    const fecha = new Date();
    const año = fecha.getFullYear();
    let mes = fecha.getMonth() + 1;
    let dia = fecha.getDate();
    mes = mes < 10 ? "0" + mes : mes;
    dia = dia < 10 ? "0" + dia : dia;
    return `${año}-${mes}-${dia}`;
  };
  const onClickAvanzar = () => {
    if (diasSeleccionados.length >= 3 && rangoHorarioSeleccionado.length >= 1) {
      setNuevoTurno({ fechaDesdeKinesio: obtenerFechaDeHoy() })(
        nuevoTurnoDispatch,
      );
      const dtoKin = createDtoTurnosDisponiblesKin({
        listDias: diasSeleccionados,
        listHorario: rangoHorarioSeleccionado,
        fechaDesde: obtenerFechaDeHoy(),
        particular: dtoBusqueda?.GruposMedico?.[0].Particular,
        idGrupoMedico: dtoBusqueda?.GruposMedico?.[0].Id,
        sectorTurno: sectorTurno,
      });
      setNuevoTurno({
        filtroKinesio: {
          dias: diasSeleccionados,
          horarios: rangoHorarioSeleccionado,
        },
      })(nuevoTurnoDispatch);
      setLoading(true);
      wsPostTurnosKinesioQr(dtoKin, (isCorrect, data) =>
        nextStepTurnosDisponiblesKin(isCorrect, data, dtoKin),
      )(estudioTurnosDispatch);
    } else {
      if (
        diasSeleccionados.length <= 2 &&
        rangoHorarioSeleccionado.length === 0
      ) {
        showToaster(
          {
            texto:
              "Debe seleccionar al menos 3 días de la semana y un rango horario",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      } else {
        if (diasSeleccionados.length <= 2) {
          showToaster(
            {
              texto: "Debe seleccionar al menos 3 días de la semana",
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
        }
        if (rangoHorarioSeleccionado.length === 0) {
          showToaster(
            {
              texto: "Debe seleccionar al menos un rango horario",
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
        }
      }
    }
  };

  const nextStepTurnosDisponiblesKin = (isCorrect, data, dtoKin) => {
    if (isCorrect) {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        turnos: data,
        grupoMedico: null,
        particular: dtoKin.particular,
        idEstudio: dtoBusqueda?.GruposMedico?.[0].Id,
        descEstudio: dtoBusqueda?.GruposMedico?.[0].Descripcion,
        descEspecialidad: null,
        fechaBusqueda: dtoKin.fechaDesde,
        dtoBusqueda: { ...dtoKin, osAlternativa: false },
        sectorTurno,
        volverOrigen: "ESTUDIOS",
        circuito: "KIN",
      })(turnosDisponiblesDispatch);

      hideToaster()(toasterDispatch);
      setLoading(false);
      history.push("/turnosDisponiblesKinesiologia");
    }
  };

  const onChangeDias = (dias) => {
    setDiasSeleccionados(dias);
  };

  const onChangeHorario = (rangoHorario) => {
    setRangoHorarioSeleccionado(rangoHorario);
  };

  //#endregion --------- funciones ---------------

  //#region  ----------- useEffect ---------------
  //#endregion  -------- useEffect ---------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      <Layout>
        <DiaHorarioKinesioContainer>
          <BarraAzul
            title={"Kinesiología"}
            backBtn={true}
            pacienteSeleccionado={pacienteSeleccionado?.nombre}
          />
          <DiaHorarioKinesioHeader>
            <span>Seleccione los días y horario en que se puede atender</span>
          </DiaHorarioKinesioHeader>
          <DiaHorarioKinesioBody>
            <FiltroCheck
              title={"Días disponibles"}
              values={["Todos"]}
              elementos={dias}
              defaultValue={"numero"}
              showValue={"nombre"}
              labelValue={"ubicacion"}
              htmlFor={"dias"}
              onChange={(dias) => onChangeDias(dias)}
            />
            <FiltroCheck
              title={"Rangos horarios"}
              values={["Todos"]}
              elementos={horario}
              defaultValue={"rango"}
              showValue={"descripcion"}
              labelValue={"ubicacion"}
              htmlFor={"hora"}
              onChange={(rangoHorario) => onChangeHorario(rangoHorario)}
            />
          </DiaHorarioKinesioBody>
          <DiaHorarioKinesioFooter>
            <DiaHorarioKinesioBoton onClick={onClickAvanzar}>
              Avanzar
            </DiaHorarioKinesioBoton>
          </DiaHorarioKinesioFooter>
        </DiaHorarioKinesioContainer>
      </Layout>
    </>
  );
};

export default DiaHorarioKinesio;
